import * as React from 'react';
import makeIcon from './make_icon';
import { jsx as ___EmotionJSX } from "@emotion/core";
var roundFilled = ___EmotionJSX("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M3 12C3 11.7239 3.22386 11.5 3.5 11.5H20.5C20.7761 11.5 21 11.7239 21 12C21 12.2761 20.7761 12.5 20.5 12.5H3.5C3.22386 12.5 3 12.2761 3 12Z"
});
var roundLined = ___EmotionJSX("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M3 12C3 11.7239 3.22386 11.5 3.5 11.5H20.5C20.7761 11.5 21 11.7239 21 12C21 12.2761 20.7761 12.5 20.5 12.5H3.5C3.22386 12.5 3 12.2761 3 12Z"
});
var sharpFilled = ___EmotionJSX("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M3 11.5H21V12.5H3V11.5Z"
});
var sharpLined = ___EmotionJSX("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M3 11.5H21V12.5H3V11.5Z"
});
var IconMinus = makeIcon('IconMinus', 'Minus', false, {
  roundFilled,
  roundLined,
  sharpFilled,
  sharpLined
});
export default IconMinus;